const WINDOWS_1256 = '€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے';
const MOJIBAKE_MARKERS = /طھ|ط·|ظˆ|ظٹ|ط±|ط§|ظ„|ظ…|ظ†|ط¹|ط­/u;

/** Converts strings that were decoded as Windows-1256 back to UTF-8 Arabic. */
export function repairMojibake<T>(value: T): T {
  if (typeof value === 'string') {
    return repairString(value) as unknown as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => repairMojibake(item)) as unknown as T;
  }

  if (value && typeof value === 'object') {
    const repaired = Object.entries(value as Record<string, unknown>).reduce(
      (result, [key, item]) => ({ ...result, [key]: repairMojibake(item) }),
      {},
    );
    return repaired as T;
  }

  return value;
}

function repairString(value: string): string {
  if (!MOJIBAKE_MARKERS.test(value)) {
    return value;
  }

  const bytes: number[] = [];
  for (const character of value) {
    const codePoint = character.codePointAt(0) || 0;
    if (codePoint <= 0x7f) {
      bytes.push(codePoint);
      continue;
    }

    const index = WINDOWS_1256.indexOf(character);
    if (index < 0) {
      return value;
    }
    bytes.push(index + 0x80);
  }

  try {
    const decoded = new TextDecoder('utf-8', { fatal: true }).decode(new Uint8Array(bytes));
    return decoded && decoded !== value ? decoded : value;
  } catch {
    return value;
  }
}
